import type { ReactNode } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface WrapperProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

export const Wrapper = ({ children, className, dataTestId }: WrapperProps) => (
  <div
    className={classNames(
      "flex h-full min-h-0 min-w-0 flex-1 flex-col gap-4 px-6 pb-4 pt-0",
      className,
    )}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

Wrapper.displayName = "InfiniteQueryDataTableCompass.Wrapper";
